import React, { Fragment, useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { ChromePicker } from 'react-color';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import {
  Button,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  InputGroup,
  Card,
  CardBody,
  CardImg,
  CustomInput,
  InputGroupAddon,
  InputGroupText,
  Input,
  Label,
} from 'reactstrap';
import ImageGallery from '../../../propinfo/gallery/index';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  API_FormSettings,
  gAPI_FormsBy_PropertyId,
} from '../../../../../../constants/APIs';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { setBackGroundColor } from '../../../integration/style/DigitalAssistantStyle';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import myma_logo_greyscale from '../../../../../../assets/myma_greyscale.png';
import aven_logo from '../../../../../../assets/aven_poweredlogo.png';
import Validation from '../../../../../../components/Validation';
import DefaultNotification from './DefaultNotification';
import LanguageTabs from '../../components/LanguageTabs/LanguageTabs';
import PhoneField from '../../../Guest Messaging/reservation/PhoneField';
import {
  buildPhoneNumber,
  detectUserCountry,
  splitPhoneNumber,
} from '../../../Guest Messaging/reservation/Countrydata';

const sanitizePhoneDigits = (phoneLocalNumber = '') =>
  String(phoneLocalNumber).replace(/\D/g, '').replace(/^0+/, '');

const buildDefaultNotificationContact = (contact, defaultCountry) => {
  const phoneParts = splitPhoneNumber(contact?.phoneNumber, defaultCountry);

  return {
    ...contact,
    phoneCountry: phoneParts.country,
    phoneLocalNumber: phoneParts.localNumber,
  };
};

const normalizeDefaultNotificationContacts = (contacts = [], defaultCountry) =>
  (contacts || []).map((contact) =>
    buildDefaultNotificationContact(contact, defaultCountry)
  );

const hasMissingNotificationEmail = (contacts = []) =>
  (contacts || []).some((contact) => !String(contact?.email || '').trim());

function FormSettings({
  propertyId,
  LoadSetting,
  settings,
  locale,
  serviceProvider,
}) {
  const defaultCountry = detectUserCountry();
  const [loading, setLoading] = useState(true);
  const [edit, setEdit] = useState(true);
  const [showEmailValidationErrors, setShowEmailValidationErrors] =
    useState(false);
  const [formSettings, setFormSettings] = useState(
    settings !== null
      ? settings
      : {
          groupId: getGroupID(),
          propertyId: propertyId,
          privacyLink: 'https://www.myma.ai/privacy-policy',
          footerLogo: myma_logo_greyscale,
          isHideFooterLogo: false,
          colors: {
            buttonColor: '#4a89dc',
            buttonTextColor: '#ffff',
          },
          defaultNotification: [],
          defaultForms: {
            isFeedbackForm: false,
            isLeaveMessageForm: false,
            feedbackFormId: '',
            leaveMessageFormId: '',
          },
          type: 'Form',
          privacyUrl: [],
        }
  );
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [error, setError] = useState(true);
  const [iseditMode, setEditMode] = useState({
    buttonColor: false,
    buttonTextColor: false,
  });
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [isContact, setIsContact] = useState(false);
  const [formData, setFormsData] = useState([]);
  const [propertyLanguages, setPropertyLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState(locale);

  useEffect(() => {
    if (settings) {
      setFormSettings({
        ...settings,
        defaultNotification: normalizeDefaultNotificationContacts(
          settings.defaultNotification,
          defaultCountry
        ),
      });
    }
    setLoading(false);
    AxiosAPI({
      method: 'get',
      url: `${gAPI_FormsBy_PropertyId}?groupId=${getGroupID()}&propertyId=${propertyId}&lang=${locale}`,
    })
      .then((res) => {
        setFormsData(res.data);
      })
      .catch((err) => console.error(err));
  }, [settings]);

  useEffect(() => {
    if (!settings || !settings.privacyUrl) return;
    const selectedLang = normalizeLang(selectedLanguage);

    let filtered = settings.privacyUrl.filter(
      (item) => item.lang === selectedLang
    );

    if (filtered.length === 0) {
      filtered = settings.privacyUrl.filter((item) => item.lang === 'en');
    }
    const url = filtered.length > 0 ? filtered[0].url : '';
    setFormSettings((prev) => ({
      ...prev,
      privacyLink: url,
    }));
  }, [selectedLanguage, settings]);

  const SetClose = () => {
    setEditMode({
      buttonColor: false,
      buttonTextColor: false,
    });
  };
  const CloseColorBox = (event) => {
    if (
      iseditMode.buttonColor === true ||
      iseditMode.buttonTextColor === true
    ) {
      SetClose();
    }
  };
  const togglegallery = () => {
    setGalleryVisible(!galleryVisible);
  };
  const selectedImage = (image) => {
    if (image !== undefined) {
      setFormSettings({ ...formSettings, footerLogo: image.src });
    }
  };
  // const handleInputChange = (e) => {
  //     setFormSettings({ ...formSettings, privacyLink: e.target.value });
  // }
  const handleCheckedFooterLogo = (e) => {
    setFormSettings({ ...formSettings, isHideFooterLogo: e.target.checked });
  };
  const handleFeedbackCheck = (value) => {
    var data = { ...formSettings.defaultForms };
    data.isFeedbackForm = value;
    setFormSettings({ ...formSettings, defaultForms: data });
  };
  const handleLeaveMsgCheck = (value) => {
    var data = { ...formSettings.defaultForms };
    data.isLeaveMessageForm = value;
    setFormSettings({ ...formSettings, defaultForms: data });
  };
  const handleFormChange = (value) => {
    var data = { ...formSettings.defaultForms };
    if (value.target.name === 'feedbackFormId') {
      data.feedbackFormId = value.target.value;
    } else if (value.target.name === 'leaveMessageFormId') {
      data.leaveMessageFormId = value.target.value;
    }
    setFormSettings({ ...formSettings, defaultForms: data });
  };
  const handleSave = () => {
    if (hasMissingNotificationEmail(formSettings.defaultNotification)) {
      setShowEmailValidationErrors(true);
      return;
    }

    setShowEmailValidationErrors(false);

    setLoading(true);

    const dataToSave = {
      ...formSettings,
      defaultNotification: (formSettings.defaultNotification || []).map(
        ({ phoneCountry, phoneLocalNumber, ...restContact }) => ({
          ...restContact,
        })
      ),
      footerLogo:
        formSettings.footerLogo ||
        (serviceProvider === '2' || serviceProvider === '5'
          ? aven_logo
          : myma_logo_greyscale),
    };

    AxiosAPI({
      method: 'post',
      url: `${API_FormSettings}/save`,
      data: dataToSave,
    })
      .then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          LoadSetting();
          setTimeout(() => {
            setLoading(false);
          }, 500);
        }
      })
      .catch((err) => {
        console.log('err', err);
      });
  };
  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>Select Logo</ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    const selectedLang = normalizeLang(selectedLanguage);
    let updated = formSettings.privacyUrl ? [...formSettings.privacyUrl] : [];
    const filtered = updated.filter((item) => item.lang === selectedLang);
    if (filtered.length > 0) {
      updated = updated.map((item) =>
        item.lang === selectedLang ? { ...item, url: value } : item
      );
    } else {
      updated.push({ lang: selectedLang, url: value });
    }
    setFormSettings({
      ...formSettings,
      privacyLink: value,
      privacyUrl: updated,
    });
  };

  const setLanguage = (e) => setSelectedLanguage(e === 'zh-TW' ? 'hk' : e);
  const normalizeLang = (lang) => (lang === 'hk' ? 'zh-TW' : lang);

  return (
    <>
      <Card className="p-4">
        <h4 className="m-0">
          Customize your forms to seamlessly match your business's brand
        </h4>
        <div
          name="bodyClick"
          className="m-0 p-0"
          onClick={(e) => {
            CloseColorBox(e);
          }}
        >
          {loading === false && formSettings && formSettings !== null ? (
            <div>
              <Separator className="my-2" />
              <Card className="my-3">
                <Colxx xxs="12" className="p-4">
                  <div className="mb-2">
                    <h6 className="mb-1">Footer Logo</h6>
                    <p>When added, the logo shows at button of the form</p>
                  </div>
                  <Row className="px-2">
                    <Colxx xxs="6" className="px-2">
                      {formSettings?.footerLogo && (
                        <Card style={{ display: 'inline-block' }}>
                          <div className="thumbnail">
                            <img
                              className="list-thumbnail responsive img-fluid border-0"
                              src={formSettings.footerLogo}
                              alt="Footer Logo"
                              style={{
                                maxWidth: '250px',
                                width: '100%',
                                height: 'auto',
                                objectFit: 'contain',
                                display: 'block',
                                padding: '5px',
                              }}
                            />
                          </div>
                        </Card>
                      )}
                      <div className="my-2">
                        <Button
                          color="success"
                          size="xs"
                          className="my-1"
                          onClick={togglegallery}
                        >
                          Browse Logo
                        </Button>
                      </div>
                      <CustomInput
                        className="mt-2 ml-1"
                        key="isHideFooterLogo"
                        type="checkbox"
                        checked={formSettings.isHideFooterLogo}
                        onChange={(e) => handleCheckedFooterLogo(e)}
                      >
                        <span>Hide Footer Logo</span>
                      </CustomInput>
                    </Colxx>
                  </Row>
                  <Separator className="mb-4 mt-3" />
                  <Colxx xxs="6" className="px-0">
                    <div className="mb-2">
                      <h6 className="mb-1">Button Colors</h6>
                      <p>Choose from button color and its text color</p>
                    </div>
                    <div className="d-flex justify-content-start">
                      <div
                        className="row "
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <div className="col-md-10 mb-1  text-left">
                          <span className="">Button Color</span>
                        </div>
                        <div className="col-md-10">
                          <InputGroup style={{ gap: '10px' }}>
                            <Input
                              className="input_sty"
                              type="text"
                              onChange={(e) => {
                                let colours = formSettings.colors;
                                colours.buttonColor = e.target.value;
                                setFormSettings({
                                  ...formSettings,
                                  colors: colours,
                                });
                              }}
                              value={formSettings.colors.buttonColor}
                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText
                                onClick={() => {
                                  setEditMode({
                                    ...iseditMode,
                                    buttonColor: !iseditMode.buttonColor,
                                  });
                                }}
                                className="color-square"
                                style={setBackGroundColor(
                                  formSettings.colors.buttonColor
                                )}
                              ></InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </div>
                      </div>
                      {iseditMode.buttonColor && (
                        <div className="parent-div">
                          <div
                            className="cover"
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          >
                            <ChromePicker
                              disableAlpha={true}
                              className="ml-2"
                              style={{ width: '240px' }}
                              color={formSettings.colors.buttonColor}
                              onChangeComplete={(e) => {
                                if (edit) {
                                  let colours = formSettings.colors;
                                  colours.buttonColor = e.hex;
                                  setFormSettings({
                                    ...formSettings,
                                    colors: colours,
                                  });
                                  setEditMode({
                                    ...iseditMode,
                                    buttonColor: false,
                                  });
                                } else setError(true);
                              }}
                            />
                          </div>
                        </div>
                      )}
                      <div
                        className="row"
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <div className="col-md-10 mb-1 text-left">
                          <span className="">Button Text Color</span>
                        </div>
                        <div className="col-md-10">
                          <InputGroup style={{ gap: '10px' }}>
                            <Input
                              className="input_sty"
                              type="text"
                              onChange={(e) => {
                                let colours = formSettings.colors;
                                colours.buttonTextColor = e.target.value;
                                setFormSettings({
                                  ...formSettings,
                                  colors: colours,
                                });
                              }}
                              value={formSettings.colors.buttonTextColor}
                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText
                                onClick={() => {
                                  setEditMode({
                                    ...iseditMode,
                                    buttonTextColor:
                                      !iseditMode.buttonTextColor,
                                  });
                                }}
                                className="color-square"
                                style={setBackGroundColor(
                                  formSettings.colors.buttonTextColor
                                )}
                              ></InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </div>
                      </div>
                      {iseditMode.buttonTextColor && (
                        <div className="parent-div">
                          <div
                            className="cover"
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          >
                            <ChromePicker
                              disableAlpha={true}
                              className="ml-2"
                              style={{ width: '240px' }}
                              color={formSettings.colors.buttonTextColor}
                              onChangeComplete={(e) => {
                                if (edit) {
                                  let colours = formSettings.colors;
                                  colours.buttonTextColor = e.hex;
                                  setFormSettings({
                                    ...formSettings,
                                    colors: colours,
                                  });
                                  setEditMode({
                                    ...iseditMode,
                                    buttonTextColor: false,
                                  });
                                } else setError(true);
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </Colxx>
                  <Separator className="my-4" />
                  <Colxx xxs="6" className="px-0">
                    <div>
                      <h6 className="mb-0">Privacy Policy link</h6>
                      <LanguageTabs
                        selectedTab={
                          selectedLanguage === 'hk' ? 'zh-TW' : selectedLanguage
                        }
                        setLanguage={setLanguage}
                        getPropertyLanguage={(langs) =>
                          setPropertyLanguages(langs)
                        }
                      ></LanguageTabs>
                      <Input
                        className="w-100 input_sty"
                        style={{ minHeight: '70px' }}
                        type="textarea"
                        name="privacyLink"
                        value={formSettings.privacyLink}
                        onChange={(event) => handleInputChange(event)}
                      />
                    </div>
                  </Colxx>
                  <Separator className="my-4" />
                  <Colxx xxs="12" className="px-0">
                    <h6 className="mb-1">Choose Feedback Form</h6>
                    <p className="mb-2">
                      When customer clicks on thumbs down, a standard form is
                      displayed to collect their feedback. Replace it with a
                      custom form with this option
                    </p>
                    <div className="d-flex mb-2">
                      <Switch
                        className=" agentswitch custom-switch-primary custom-switch-small"
                        checked={formSettings.defaultForms.isFeedbackForm}
                        onChange={(primary) => handleFeedbackCheck(primary)}
                      />
                      <Label className="ml-2">Use Custom Form</Label>
                    </div>
                    <Input
                      className="w-50 input_sty"
                      type="select"
                      name="feedbackFormId"
                      value={formSettings.defaultForms.feedbackFormId}
                      onChange={(e) => handleFormChange(e)}
                    >
                      <option value="">Select</option>
                      {formData &&
                        formData.map((item, i) => (
                          <option value={item.id} key={i}>
                            {item.name}
                          </option>
                        ))}
                    </Input>
                  </Colxx>
                  <Separator className="my-4" />
                  <Colxx xxs="12" className="px-0">
                    <h6 className="mb-1">Choose Leave A Message Form</h6>
                    <p className="mb-2">
                      When customer choose to leave a message,show this form
                    </p>
                    <div className="d-flex mb-2">
                      <Switch
                        className=" agentswitch custom-switch-primary custom-switch-small"
                        checked={formSettings.defaultForms.isLeaveMessageForm}
                        onChange={(primary) => handleLeaveMsgCheck(primary)}
                      />
                      <Label className="ml-2">Use Custom Form</Label>
                    </div>
                    <Input
                      className="w-50 input_sty"
                      type="select"
                      name="leaveMessageFormId"
                      value={formSettings.defaultForms.leaveMessageFormId}
                      onChange={(e) => handleFormChange(e)}
                    >
                      <option value="">Select</option>
                      {formData &&
                        formData.map((item, i) => (
                          <option value={item.id} key={i}>
                            {item.name}
                          </option>
                        ))}
                    </Input>
                  </Colxx>
                  <Separator className="my-4" />
                  <Colxx xxs="12" className="px-0">
                    <h6 className="mb-1">Default Notification</h6>
                    <p className="mb-2">
                      Add a fallback email address, which will receive form
                      submission notification in case there is no other email
                      subscribed to the form.
                    </p>
                    <div className="contacts-scroll-modal">
                      <div className="contacts-rows-scroll">
                        <div
                          className="contacts-table-header-row contacts-table-grid"
                          style={{
                            gridTemplateColumns: '3fr 4fr 1fr 3.5fr 1.2fr',
                          }}
                        >
                          <div className="contacts-table-cell">Name</div>
                          <div className="contacts-table-cell">
                            Email <span style={{ color: 'red' }}> *</span>
                          </div>
                          <div className="contacts-table-cell contacts-table-cell--center">
                            BCC
                          </div>
                          <div className="contacts-table-cell">
                            Phone Number (for SMS Notification)
                          </div>
                          <div className="contacts-table-cell contacts-table-cell--center">
                            Remove
                          </div>
                        </div>
                        {(formSettings.defaultNotification || []).map(
                          (contact, index) => {
                            return (
                              <div
                                key={index}
                                className="contacts-table-row contacts-table-grid"
                                style={{
                                  gridTemplateColumns:
                                    '3fr 4fr 1fr 3.5fr 1.2fr',
                                }}
                              >
                                <div className="contacts-table-cell">
                                  <Input
                                    className="contacts-cell-input"
                                    type="text"
                                    placeholder="Name"
                                    value={contact.name || ''}
                                    onChange={(e) => {
                                      const updated = [
                                        ...formSettings.defaultNotification,
                                      ];
                                      updated[index] = {
                                        ...updated[index],
                                        name: e.target.value,
                                      };
                                      setFormSettings({
                                        ...formSettings,
                                        defaultNotification: updated,
                                      });
                                    }}
                                  />
                                </div>
                                <div className="contacts-table-cell contacts-table-cell--with-validation">
                                  <Input
                                    className={`contacts-cell-input ${
                                      showEmailValidationErrors &&
                                      !String(contact?.email || '').trim()
                                        ? 'contacts-cell-input--error'
                                        : ''
                                    }`}
                                    type="text"
                                    placeholder="Email"
                                    value={contact.email || ''}
                                    onChange={(e) => {
                                      const updated = [
                                        ...formSettings.defaultNotification,
                                      ];
                                      updated[index] = {
                                        ...updated[index],
                                        email: e.target.value,
                                      };
                                      setFormSettings({
                                        ...formSettings,
                                        defaultNotification: updated,
                                      });
                                    }}
                                  />
                                  {showEmailValidationErrors &&
                                    !String(contact?.email || '').trim() && (
                                      <div className="contacts-field-error-text">
                                        Required
                                      </div>
                                    )}
                                </div>
                                <div className="contacts-table-cell contacts-table-cell--center">
                                  <CustomInput
                                    type="checkbox"
                                    id={`bcc-${index}`}
                                    checked={contact.isBcc || false}
                                    name="isBcc"
                                    onChange={(e) => {
                                      const updated = [
                                        ...formSettings.defaultNotification,
                                      ];
                                      updated[index] = {
                                        ...updated[index],
                                        isBcc: e.target.checked,
                                      };
                                      setFormSettings({
                                        ...formSettings,
                                        defaultNotification: updated,
                                      });
                                    }}
                                  />
                                </div>
                                <div className="contacts-table-cell">
                                  <PhoneField
                                    id={`default-notification-phone-${index}`}
                                    label="Phone Number"
                                    showLabel={false}
                                    showValidation={false}
                                    useBaseInputShell={true}
                                    baseInputClassName="contacts-cell-input"
                                    countryWidth={108}
                                    country={
                                      contact.phoneCountry || defaultCountry
                                    }
                                    localNumber={contact.phoneLocalNumber || ''}
                                    disabled={false}
                                    onCountryChange={(country) => {
                                      const updated = [
                                        ...formSettings.defaultNotification,
                                      ];
                                      const currentLocalNumber =
                                        sanitizePhoneDigits(
                                          updated[index]?.phoneLocalNumber
                                        );
                                      updated[index] = {
                                        ...updated[index],
                                        phoneCountry: country,
                                        phoneLocalNumber: currentLocalNumber,
                                        phoneNumber: buildPhoneNumber(
                                          country,
                                          currentLocalNumber
                                        ),
                                      };
                                      setFormSettings({
                                        ...formSettings,
                                        defaultNotification: updated,
                                      });
                                    }}
                                    onNumberChange={(localNumber, metadata) => {
                                      const updated = [
                                        ...formSettings.defaultNotification,
                                      ];
                                      const nextLocalNumber =
                                        sanitizePhoneDigits(localNumber);
                                      const nextCountry =
                                        metadata?.detectedCountry ||
                                        updated[index]?.phoneCountry ||
                                        defaultCountry;
                                      updated[index] = {
                                        ...updated[index],
                                        phoneCountry: nextCountry,
                                        phoneLocalNumber: nextLocalNumber,
                                        phoneNumber: buildPhoneNumber(
                                          nextCountry,
                                          nextLocalNumber
                                        ),
                                      };
                                      setFormSettings({
                                        ...formSettings,
                                        defaultNotification: updated,
                                      });
                                    }}
                                  />
                                </div>
                                <div className="contacts-table-cell contacts-table-cell--center">
                                  <Button
                                    color="secondary"
                                    size="xs"
                                    outline
                                    className="contacts-remove-button"
                                    onClick={() => {
                                      const updated = [
                                        ...formSettings.defaultNotification,
                                      ];
                                      updated.splice(index, 1);
                                      setFormSettings({
                                        ...formSettings,
                                        defaultNotification: updated,
                                      });
                                    }}
                                  >
                                    -
                                  </Button>
                                </div>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </div>
                    <Button
                      color="secondary"
                      size="xs"
                      outline
                      className="mt-1"
                      onClick={() => {
                        const updated = [
                          ...(formSettings.defaultNotification || []),
                        ];
                        updated.push({
                          name: '',
                          email: '',
                          phoneNumber: '',
                          phoneCountry: defaultCountry,
                          phoneLocalNumber: '',
                          isBcc: false,
                        });
                        setFormSettings({
                          ...formSettings,
                          defaultNotification: updated,
                        });
                      }}
                    >
                      + Add Notification
                    </Button>
                  </Colxx>
                </Colxx>
              </Card>
              <Separator className="mt-2 mb-4" />
              <Colxx xxs="12" className="pb-2">
                <Button color="primary" size="xs" onClick={() => handleSave()}>
                  Save
                </Button>
              </Colxx>
            </div>
          ) : (
            <div className="loading" />
          )}
        </div>
      </Card>
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
      {ImageGalleryButton()}
    </>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, serviceProvider } = settings;
  return {
    propertyId,
    locale,
    serviceProvider,
  };
};

export default injectIntl(connect(mapStateToProps, {})(FormSettings));
